// 在互客 自定义工具中 iframe的页面 不允许使用 localStorage、且cookie无法使用

// 因此以此替换
import store from '@/store'

const all_change_method_list = {
  'app_key': (val) => store.dispatch('huke/changeAppKey', val),
  'ciphertext': (val) => store.dispatch('huke/changeCiphertext', val),
  'huke_token': (val) => store.dispatch('huke/changeHukeToken', val),
  'huke_org_id': (val) => store.dispatch('huke/changeHukeOrgid', val),
  'huke_roles': (val) => store.dispatch('huke/changeHukeRoles', val),
  'huke_org': (val) => store.dispatch('huke/chnageHukeOrg', val),
  'huke_profile_id': (val) => store.dispatch('huke/changeHukeProfileId', val),
  'huke_profile': (val) => store.dispatch('huke/changeHukeProfile', val)
}

export function storeSet (prop, val) {
  // Lockr.set(prop, val)

  const setFunc = all_change_method_list[prop]

  // console.log(setFunc, 'setFunc')

  // console.log(prop, val, 'prop, val storeSet')

  if (typeof setFunc === 'function') {
    setFunc(val)
  }
}

export function storeGet (prop, defaultVal) {
  // If value is null or undefined it returns a defaultVal
  // const new_prop = lockr_prefix + prop

  // console.log(new_prop, 'new_prop')

  // console.log(Lockr.getAll(true))
  // console.log(Lockr.get(prop), 'prop get')
  // console.log(Lockr.get(new_prop), 'new_prop get')

  // lockrFlush()

  // return Lockr.get(prop, defaultVal)
  // console.log(all_get_key_val_list, 'all_get_key_val_list')

  const all_get_key_val_list = {
    'app_key': store.state.huke.app_key,
    'ciphertext': store.state.huke.ciphertext,
    'huke_token': store.state.huke.huke_token,
    'huke_org_id': store.state.huke.huke_org_id,
    'huke_roles': store.state.huke.huke_roles,
    'huke_org': store.state.huke.huke_org,
    'huke_profile_id': store.state.huke.huke_profile_id,
    'huke_profile': store.state.huke.huke_profile
  }

  // console.log(all_get_key_val_list, 'all_get_key_val_list storeGet')

  // console.log(all_get_key_val_list[prop], prop, defaultVal, 'all_get_key_val_list[prop] , prop, defaultVal storeGet')

  return all_get_key_val_list[prop] || defaultVal
}

export function storeRm (prop) {
  // const new_prop = lockr_prefix + prop

  // Lockr.rm(prop)

  const setFunc = all_change_method_list[prop]

  if (typeof setFunc === 'function') {
    setFunc('')
  }
}

